/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface TesterNavigationSidebarUser {
  slug: string | null;
  isModerator: boolean;
  /** True when the user does NOT have TESTER_PROFILE_UX_2026 — the sidebar's
   *  Tester Profile section then points at legacy account.* routes and shows
   *  "Payments" instead of "Earnings". */
  isLegacyTesterProfile: boolean;
  hasAcademyCertificationsRedesign: boolean;
  hasUserIdentityVerification: boolean;
  isByot: boolean;
  isTester: boolean;
}

export interface TesterNavigationSidebarUrls {
  home: string;
  /** URL for the chat link shown in the mobile-only bottom nav. Empty string means no chat is configured. */
  chatUrl: string;
  /** URL for the notifications/activity link shown in the mobile-only bottom nav. */
  notificationsUrl: string;
  /** Active-state-only key for the Tester Profile parent row. Adapters set
   *  this to the empty string — the parent doesn't navigate — but provide a
   *  matcher in isActive$ so legacy states without a direct sidebar link
   *  (account.myProfile.interests / paymentTesting / subscriptions) keep the
   *  parent highlighted without falsely highlighting any child. */
  testerProfileSection: string;
  testerProfilePersonal: string;
  testerProfileDevicesAndEnvironments: string;
  testerProfileAdditionalInfo: string;
  testerProfileEarnings: string;
  testerProfileStatistics: string;
  testerProfileIdentity: string;
  projectsOverview: string;
  projectsTestCycles: string;
  projectsIssues: string;
  projectsTestCases: string;
  projectsBoard: string;
  academy: string;
  academyCatalog: string;
  academyCertifications: string;
  communityFeed: string;
  communityArticles: string;
  communityForum: string;
  communityProfile: string;
  moderatorReviewArticles: string;
  moderatorFlaggedContent: string;
  moderatorTransferForums: string;
  moderatorUrlShortener: string;
}

export type TesterNavigationSidebarUrlKey = keyof TesterNavigationSidebarUrls;

export interface TesterNavigationSidebarService {
  user$: Observable<TesterNavigationSidebarUser>;
  urls$: Observable<TesterNavigationSidebarUrls>;
  isActive$(key: TesterNavigationSidebarUrlKey): Observable<boolean>;
}

export const TESTER_NAVIGATION_SIDEBAR_SERVICE =
  new InjectionToken<TesterNavigationSidebarService>('TesterNavigationSidebarService');
